/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-13T17:19:55.607
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentSerComplaintEvaluate,
	listRentSerComplaintEvaluateInit,
	listRentSerComplaintEvaluateByAuthorizations,
	deleteRentSerComplaintEvaluate
} from '@api/rentmanage/RentSerComplaintEvaluate';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentSerComplaintEvaluate({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintEvaluate(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentSerComplaintEvaluateByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintEvaluateByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentSerComplaintEvaluateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentSerComplaintEvaluateInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentSerComplaintEvaluate({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentSerComplaintEvaluate({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
